import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { NewsAndGuidesDetailsPagePrefetchedDataProps } from 'src/app/pages/newsAndGuides/details/pageContext';
import {
	NewsAndGuidesDetailsPageContextProvider,
	prefetchPageContext,
} from 'src/app/pages/newsAndGuides/details/pageContext';

import { Layout } from '../layout';

import { NewsAndGuidesDetailsErrorHandler } from './ErrorHandler';

export const NewsAndGuidesDetails = withPrefetchedData(
	function NewsAndGuidesDetails({ prefetchedData }: NewsAndGuidesDetailsPagePrefetchedDataProps) {
		const { countryCode, slug } = useKnownAvailableParams<{ countryCode: string; slug: string }>();

		return (
			<NewsAndGuidesDetailsPageContextProvider
				slug={slug}
				countryCode={countryCode}
				prefetchedData={prefetchedData}
				errorHandler={NewsAndGuidesDetailsErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</NewsAndGuidesDetailsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.countryCode!, context.params.slug!, context),
	},
);
